import { render } from "./X.vue?vue&type=template&id=c78c3f4c&scoped=true"
import script from "./X.vue?vue&type=script&lang=js"
export * from "./X.vue?vue&type=script&lang=js"

import "./X.vue?vue&type=style&index=0&id=c78c3f4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78c3f4c"]])

export default __exports__